// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || `${window.location.origin}/api/v1`,
  TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT || '5000', 10),
  RETRY_COUNT: parseInt(process.env.REACT_APP_API_RETRY_COUNT || '3', 10),
  RETRY_DELAY: parseInt(process.env.REACT_APP_API_RETRY_DELAY || '1000', 10),
};

// Authentication Configuration
export const AUTH_CONFIG = {
  TOKEN_KEY: process.env.REACT_APP_TOKEN_KEY || 'token',
  REFRESH_TOKEN_KEY: process.env.REACT_APP_REFRESH_TOKEN_KEY || 'refresh_token',
  TOKEN_EXPIRY: parseInt(process.env.REACT_APP_TOKEN_EXPIRY || '30', 10), // minutes
  REFRESH_TOKEN_EXPIRY: parseInt(process.env.REACT_APP_REFRESH_TOKEN_EXPIRY || '7', 10), // days
};

// Application Configuration
export const APP_CONFIG = {
  NAME: process.env.REACT_APP_NAME || 'Cyberlagebild',
  VERSION: process.env.REACT_APP_VERSION || '1.0.0',
  ENVIRONMENT: process.env.REACT_APP_ENV || 'development',
  DEBUG: process.env.REACT_APP_DEBUG === 'true',
};

// Feature Flags
export const FEATURE_FLAGS = {
  ENABLE_ANALYTICS: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
  ENABLE_LOGGING: process.env.REACT_APP_ENABLE_LOGGING === 'true',
  ENABLE_ERROR_REPORTING: process.env.REACT_APP_ENABLE_ERROR_REPORTING === 'true',
}; 